<template>
  <gas-page-shell :breadcrumb="['系统设置', '基础设置']">
    <el-form v-loading="loading" label-width="120px" size="small" class="gas-form">
      <el-form-item label="系统名称">
        <div class="hint">显示在浏览器标题栏（配置键 system.name）</div>
        <el-input v-model="form['system.name']" />
      </el-form-item>
      <el-form-item label="公司名称">
        <div class="hint">显示在顶栏品牌区（配置键 company.name）</div>
        <el-input v-model="form['company.name']" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="公司 Logo">
        <div class="hint">显示在顶栏公司名称左侧（配置键 company.logo，PNG/JPG/GIF/WEBP/SVG，不超过 2MB）</div>
        <div class="logo-row">
          <img :src="logoPreview" alt="logo" class="logo-preview" />
          <div class="logo-actions">
            <el-upload
              :show-file-list="false"
              accept="image/png,image/jpeg,image/gif,image/webp,image/svg+xml,.png,.jpg,.jpeg,.gif,.webp,.svg"
              action=""
              :http-request="onLogoUpload"
              :disabled="logoUploading"
            >
              <el-button size="small" type="primary" plain :loading="logoUploading">上传图片</el-button>
            </el-upload>
            <el-button
              v-if="hasCustomLogo"
              size="small"
              :loading="logoClearing"
              @click="onClearLogo"
            >
              恢复默认
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="saveConfig">保存设置</el-button>
      </el-form-item>
    </el-form>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import { gasApi } from '@/api/gas'
import { refreshSiteBranding, resolveLogoUrl } from '@/utils/siteBranding'

export default {
  components: { GasPageShell },
  data() {
    return {
      loading: false,
      saving: false,
      logoUploading: false,
      logoClearing: false,
      logoPreviewVersion: 0,
      form: {
        'system.name': '',
        'company.name': '',
        'company.logo': ''
      }
    }
  },
  computed: {
    hasCustomLogo() {
      return !!(this.form['company.logo'] && String(this.form['company.logo']).trim())
    },
    logoPreview() {
      return resolveLogoUrl(this.form['company.logo'], this.logoPreviewVersion)
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      this.loading = true
      try {
        const res = await gasApi.sysConfig.get()
        const d = res.data || {}
        this.form['system.name'] = d['system.name'] || ''
        this.form['company.name'] = d['company.name'] || ''
        this.form['company.logo'] = d['company.logo'] || ''
        this.logoPreviewVersion = Date.now()
      } finally {
        this.loading = false
      }
    },
    async saveConfig() {
      this.saving = true
      try {
        await gasApi.sysConfig.save({
          'system.name': this.form['system.name'],
          'company.name': this.form['company.name']
        })
        await refreshSiteBranding()
        this.$message.success('保存成功')
      } finally {
        this.saving = false
      }
    },
    async onLogoUpload({ file }) {
      this.logoUploading = true
      try {
        const res = await gasApi.sysConfig.uploadCompanyLogo(file)
        this.form['company.logo'] = (res.data && res.data.url) || '/api/gas/system/company-logo'
        this.logoPreviewVersion = Date.now()
        await refreshSiteBranding()
        this.$message.success('Logo 已更新')
      } finally {
        this.logoUploading = false
      }
    },
    async onClearLogo() {
      try {
        await this.$confirm('确定恢复为默认 Logo？', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      this.logoClearing = true
      try {
        await gasApi.sysConfig.clearCompanyLogo()
        this.form['company.logo'] = ''
        this.logoPreviewVersion = Date.now()
        await refreshSiteBranding()
        this.$message.success('已恢复默认 Logo')
      } finally {
        this.logoClearing = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color:#86909c; font-size:12px; margin-bottom:6px; }
.gas-form { max-width: 640px; }
.logo-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.logo-preview {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  padding: 4px;
  background: #fff;
}
.logo-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
